<template>
  <div class="a-modal-pop row justify-content-center align-items-center" id="pz-question-report">
    <!-- <div class="col-md-7 col-lg-6 h-100 d-flex align-items-center justify-content-center"> -->
    <div class="modal-pop shadow-lg bg-white d-flex flex-column">
      <div
        class="modal-pop-header border-bottom p-3 d-flex justify-content-between align-items-center"
      >
        <h5 class="mb-0">习题纠错</h5>
        <button
          class="btn btn-link text-dark"
          type="button"
          ref="closeButton"
          data-toggle="collapse"
          data-target="#pz-question-report"
          aria-expanded="false"
          aria-controls="a-sheet"
        >
          <i class="pz-icon icon-close"></i>
        </button>
      </div>
      <div class="modal-pop-body p-5 overflow-auto">
        <div class="custom-control custom-radio mb-3">
          <input
            type="radio"
            id="err0"
            v-model="errInfo"
            value="公式显示不正确"
            class="custom-control-input"
          />
          <label for="err0" class="custom-control-label">公式显示不正确</label>
          <textarea
            v-model="errDesc"
            class="form-control"
            placeholder="问题具体描述..."
            maxlength="1000"
            rows="4"
            style="resize: none"
            v-show="'公式显示不正确' === errInfo"
          />
        </div>
        <div class="custom-control custom-radio mb-3">
          <input
            type="radio"
            id="err1"
            v-model="errInfo"
            value="题干错误"
            class="custom-control-input"
          />
          <label for="err1" class="custom-control-label">题干错误</label>
          <textarea
            v-model="errDesc"
            class="form-control"
            placeholder="问题具体描述..."
            maxlength="1000"
            rows="4"
            style="resize: none"
            v-show="'题干错误' === errInfo"
          />
        </div>
        <div class="custom-control custom-radio mb-3">
          <input
            type="radio"
            id="err2"
            v-model="errInfo"
            value="选项错误"
            class="custom-control-input"
          />
          <label for="err2" class="custom-control-label">选项错误</label>
          <textarea
            v-model="errDesc"
            class="form-control"
            placeholder="问题具体描述..."
            maxlength="1000"
            rows="4"
            style="resize: none"
            v-show="'选项错误' === errInfo"
          />
        </div>
        <div class="custom-control custom-radio mb-3">
          <input
            type="radio"
            id="err3"
            v-model="errInfo"
            value="答案判断及提示不正确"
            class="custom-control-input"
          />
          <label for="err3" class="custom-control-label">答案判断及提示不正确</label>
          <textarea
            v-model="errDesc"
            class="form-control"
            placeholder="问题具体描述..."
            maxlength="1000"
            rows="4"
            style="resize: none"
            v-show="'答案判断及提示不正确' === errInfo"
          />
        </div>
        <div class="custom-control custom-radio mb-3">
          <input
            type="radio"
            id="err4"
            v-model="errInfo"
            value="解析错误"
            class="custom-control-input"
          />
          <label for="err4" class="custom-control-label">解析错误</label>
          <textarea
            v-model="errDesc"
            class="form-control"
            placeholder="问题具体描述..."
            maxlength="1000"
            rows="4"
            style="resize: none"
            v-show="'解析错误' === errInfo"
          />
        </div>
        <div class="custom-control custom-radio mb-3">
          <input
            type="radio"
            id="err5"
            v-model="errInfo"
            value="知识点对应错误"
            class="custom-control-input"
          />
          <label for="err5" class="custom-control-label">知识点对应错误</label>
          <textarea
            v-model="errDesc"
            class="form-control"
            placeholder="问题具体描述..."
            maxlength="1000"
            rows="4"
            style="resize: none"
            v-show="'知识点对应错误' === errInfo"
          />
        </div>
        <div class="custom-control custom-radio mb-3">
          <input
            type="radio"
            id="err5"
            v-model="errInfo"
            value="其它问题"
            class="custom-control-input"
          />
          <label for="err5" class="custom-control-label">其它问题</label>
          <textarea
            v-model="errDesc"
            class="form-control"
            placeholder="问题具体描述..."
            maxlength="1000"
            rows="4"
            style="resize: none"
            v-show="'其它问题' === errInfo"
          />
        </div>

        <!-- <textarea
          v-model="errDesc"
          class="form-control"
          :class="!c_otherError && 'd-none'"
          placeholder="问题具体描述..."
          maxlength="1000"
          style="resize: none;"
          rows="4"
        />-->
      </div>
      <div class="modal-pop-footer border-top p-3 d-flex justify-content-center">
        <button
          type="button"
          @click="questionReport"
          :disabled="!errInfo"
          class="btn btn-primary py-2 px-4 ml-3"
        >
          提交
        </button>
        <button
          type="button"
          class="btn btn-secondary py-2 px-4 ml-3"
          data-toggle="collapse"
          data-target="#pz-question-report"
          aria-expanded="false"
          aria-controls="a-modal-pop"
        >
          取消
        </button>
      </div>
    </div>
    <!-- </div> -->

    <!-- <div class="modal-dialog shadow-lg">

    </div>-->

    <!-- <div class="modal-header align-items-center bg-light pl-5">
      <div class="flex-grow-1 d-flex align-items-center">
        <h5 class="modal-title mr-5">习题纠错</h5>
      </div>
      <button class="btn btn-link text-dark" type="button" ref="closeButton" data-toggle="collapse" data-target="#pz-question-report" aria-expanded="false" aria-controls="a-sheet">
        <i class="pz-icon icon-close"></i>
      </button>
    </div>
    <div class="modal-body p-5">
      <div class="custom-control custom-radio">
        <input type="radio" id="err0" v-model="errInfo" value="公式显示不正确" class="custom-control-input" />
        <label for="err0" class="custom-control-label">公式显示不正确</label>
      </div>
      <div class="custom-control custom-radio">
        <input type="radio" id="err1" v-model="errInfo" value="内容有误" class="custom-control-input" />
        <label for="err1" class="custom-control-label">内容有误</label>
      </div>
      <div class="custom-control custom-radio">
        <input type="radio" id="err2" v-model="errInfo" value="试题内容为空" class="custom-control-input" />
        <label for="err2" class="custom-control-label">试题内容为空</label>
      </div>
      <div class="custom-control custom-radio">
        <input type="radio" id="err3" v-model="errInfo" value="答案判断及提示不正确" class="custom-control-input" />
        <label for="err3" class="custom-control-label">答案判断及提示不正确</label>
      </div>
      <div class="custom-control custom-radio">
        <input type="radio" id="err4" v-model="errInfo" value="其它问题" class="custom-control-input" />
        <label for="err4" class="custom-control-label">其它问题</label>
      </div>

      <button type="button" @click="questionReport" :disabled="!errInfo" class="btn btn-primary py-2 px-5 ml-3">提交</button>
      <button type="button" class="btn btn-secondary py-2 px-5 ml-3" data-toggle="collapse" data-target="#pz-question-report" aria-expanded="false" aria-controls="a-sheet">取消</button>
    </div>
    </div>-->
  </div>
</template>

<script>
import Swal from 'sweetalert2';

import { questionReport } from '@/global/service';

export default {
  name: 'QuestionReport',

  components: {},

  props: {
    p_questionId: {
      type: Number,
      default: () => 0,
    },
  },

  data: () => {
    return {
      errInfo: '',
      errDesc: '',
    };
  },

  computed: {
    c_otherError() {
      return '其它问题' === this.errInfo;
    },
  },

  watch: {
    p_questionId() {
      this.errInfo = '';
      this.errDesc = '';
    },
  },

  methods: {
    async questionReport() {
      await questionReport({
        questionId: this.p_questionId,
        comment: this.errInfo + (this.errDesc ? '  ' + this.errDesc : ''),
      });
      await Swal.fire({
        // position: 'top-end',
        backdrop: false,
        icon: 'success',
        width: '400px',
        title: `已经反馈问题`,
        showConfirmButton: false,
        timer: 800,
      });
      this.$emit('question-reported');
      this.$refs.closeButton.click();
    },
  },
};
</script>
<style lang="scss" scoped>
#title {
  margin-left: 2em;
  margin-bottom: 1em;
}
.page-item {
  display: block;
  cursor: pointer;
  margin: 0.5em;
}
</style>
